import { Help20Px, OpenDefault20Px, ReportFilled20Px, StarFilled16Px, blue } from '@galaxy-react/core';

import {
  CardBodyFooterStyled,
  CardBodyStyled,
  CardHeaderContentStyled,
  CardHeaderDescriptionStyled,
  CardHeaderDescriptionWrapperStyled,
  CardHeaderReportNameStyled,
  CardHeaderStyled,
  CardInfoStyled,
  CardPreviewOriginalNameStyled,
  CardPreviewReportDetailsStyled,
  CardPreviewViewsAndOriginalNameStyled,
  CardStyled,
  FooterDetailsStyled,
  FooterPreviewStyled,
} from './search-preview-styled';

import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { SearchPreviewProps } from './search-preview-types';

export function SearchPreview(props: SearchPreviewProps) {
  const navigate = useNavigate();

  return (
    <CardStyled {...props}>
      <CardHeaderStyled
        hasReportDetails={!!(props.cardHeaderPreviewProps.originalName || props.cardHeaderPreviewProps.viewedNo)}
        header={
          <CardHeaderContentStyled>
            <ReportFilled20Px color={blue[500]} />
            <CardHeaderReportNameStyled>{props.cardHeaderPreviewProps.reportName}</CardHeaderReportNameStyled>
          </CardHeaderContentStyled>
        }
        description={
          <CardHeaderDescriptionWrapperStyled>
            <CardPreviewReportDetailsStyled>
              <CardInfoStyled>
                {!props.cardHeaderPreviewProps.originalName && props.cardHeaderPreviewProps.viewedNo && (
                  <span>
                    {`${props.cardHeaderPreviewProps.viewedNo}` +
                      `${props.cardHeaderPreviewProps.viewedNo === 1 ? ' view' : ' views'}`}
                  </span>
                )}
                {props.cardHeaderPreviewProps.originalName && props.cardHeaderPreviewProps.viewedNo ? (
                  <CardPreviewViewsAndOriginalNameStyled>
                    <CardPreviewOriginalNameStyled>
                      {props.cardHeaderPreviewProps.originalName}
                    </CardPreviewOriginalNameStyled>
                    {`${props.cardHeaderPreviewProps.viewedNo}` +
                      `${props.cardHeaderPreviewProps.viewedNo === 1 ? ' view' : ' views'}`}
                  </CardPreviewViewsAndOriginalNameStyled>
                ) : null}
              </CardInfoStyled>
            </CardPreviewReportDetailsStyled>
            {props.cardHeaderPreviewProps.children && <div>{props.cardHeaderPreviewProps.children}</div>}
            <CardHeaderDescriptionStyled>{props.cardHeaderPreviewProps.description}</CardHeaderDescriptionStyled>
          </CardHeaderDescriptionWrapperStyled>
        }
        action={props.cardHeaderPreviewProps.isFavoured ? <StarFilled16Px color="#F69139" /> : null}
      />
      <CardBodyStyled>
        {/* <BodyHeadingStyled>Last Run</BodyHeadingStyled>
        <BodyDetailsStyled>
          {props.cardBodyPreviewProps?.lastRun ? props.cardBodyPreviewProps.lastRun : 'N/A'}
        </BodyDetailsStyled>

        <CardBodyInfoStyled>
          <BodyHeadingStyled>Views</BodyHeadingStyled>
          <BodyDetailsStyled>{props?.cardBodyPreviewProps?.views}</BodyDetailsStyled>
        </CardBodyInfoStyled> */}
      </CardBodyStyled>
      <CardBodyFooterStyled onClick={() => props.onClick?.(null)}>
        <FooterPreviewStyled onClick={() => navigate(props.cardFooterPreviewProps.reportLink!)}>
          <OpenDefault20Px color={blue[700]} />
          <FooterDetailsStyled>Open {props.cardHeaderPreviewProps.reportName}</FooterDetailsStyled>
        </FooterPreviewStyled>
        <FooterPreviewStyled target="_blank" href={props.cardFooterPreviewProps.helpCenterLink}>
          <Help20Px color={blue[700]} />
          <FooterDetailsStyled>{t('Learn more in Help Centre')}</FooterDetailsStyled>
        </FooterPreviewStyled>
      </CardBodyFooterStyled>
    </CardStyled>
  );
}

export default SearchPreview;
